import React from 'react';
import { Image, Text, View } from 'react-native';
import { img_expand, img_check } from '../../../../utils/ImagesManagementUtils';
import { textPrimary_11_6 } from '../TextComponent/TextStyle';

//= ========================================================================
const CurrencyAmountLine = ({
  globJSON, simPlatform,
  currencyStr, withIcon, withIconPointRight,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    titleLine: {
      justifyContent: 'center',
      marginLeft: 20,
    },
    lineStyle: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: 'auto',
      height: 40,
      borderBottomWidth: 1,
      borderColor: colors.border_color,
    },
    iconStyle: {
      width: 17,
      height: 17,
      marginRight: 18,
      tintColor: colors.tertiary_icons_color,
    },
  };

  //= ====================================================================

  return (

    <View style={myStyles.lineStyle}>
      <Text style={[textPrimary_11_6(globJSON, simPlatform), myStyles.titleLine]}>
        {currencyStr}
      </Text>
      {withIcon
            && (
            <Image
              fadeDuration={0}
              style={myStyles.iconStyle}
              source={img_check}
            />
            )}
      {withIconPointRight
            && (
            <Image
              fadeDuration={0}
              style={myStyles.iconStyle}
              source={img_expand}
            />
            )}
    </View>
  );
};

export default CurrencyAmountLine;
